import { Component, Input } from "@angular/core";
import { InAppBrowser } from "@awesome-cordova-plugins/in-app-browser/ngx";
import { adminPages } from "src/services/navigation/paths.const";

@Component({
  selector: "rc-order-table-context-menu",
  template: `
    <ion-item
      class="contextmenu"
      lines="none"
      [ngStyle]="{ 'left.px': x, 'top.px': y }"
      [ngClass]="{ 'd-none': !show }">
      <ion-button
        class="dropdown-item context-menu disable-default-style"
        (mousedown)="onOpenInNewTab()"
        color="primary"
        size="small"
        fill="outline">
        Open in new tab
      </ion-button>
    </ion-item>
  `,
  styleUrls: ["./order-table-context-menu.component.scss"],
  standalone: false,
})
export class OrderTableContextMenuComponent {
  @Input() orderId: string;
  @Input() show: boolean;
  @Input() x = 0;
  @Input() y = 0;

  constructor(private readonly inAppBrowser: InAppBrowser) {}

  public onOpenInNewTab(): void {
    this.inAppBrowser.create(`${adminPages.orderDetails}/${this.orderId}`, "_blank");
  }
}
